import MembershipPlanComponent from 'components/membership';

const MembershipPage = () => {
  return <MembershipPlanComponent />;
};

export default MembershipPage;
